/* eslint-disable @typescript-eslint/ban-ts-comment, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-argument */
// @ts-ignore - This will fail to find corresponding type declarations unless compilerOptions.moduleResolution is set to "bundler" in tsconfig.json.
// But "bundler" was added in TypeScript 5 and we are still on TypeScript 4. TODO: Once updraded to TS5, set compilerOptions.moduleResolution to "bundler" and remove this comment.

import { dom, library } from "@fortawesome/fontawesome-svg-core";

// Solid icons
import {
  faRefresh,
  faPlus,
  faGear,
  faChevronLeft,
  faInfoCircle,
  faUsers,
  faUser,
  faUserCircle,
  faTimes,
  faPencil,
  faTrash,
  faFloppyDisk,
  faPrint,
  faDownload,
  faArrowRight,
  faTrashCan,
  faExchange,
  faObjectGroup,
  faCalendarCheck,
  faCalendarDays,
  faCalendarDay,
  faCalendarWeek,
  faCalendarLines,
  faCalendarArrowUp,
  faCalendarRange,
  faEye,
  faEllipsis,
  faExclamationTriangle,
  faCaretLeft,
  faLongArrowDown,
  faLongArrowUp,
  faRotate,
  faRotateLeft,
  faWifi,
  faArrowDown,
  faEdit,
  faArrowsRotate,
  faCircleQuestion,
  faBell,
  faBan,
  faSearch,
  faFile,
  faCog,
  faSave,
  faLock,
  faComment,
  faPhone,
  faEnvelope,
  faPaperPlane,
  faQuestion,
  faCheckCircle,
  faWarning,
  faBookmark,
  faLinkSimpleSlash,
  faCircleMinus,
  faAnalytics,
  faFileAlt,
  faShieldHalved,
  faFilter,
  faEarthAmericas,
  faFamily,
  faBug,
  faChevronDown,
  faChevronRight,
  faBellExclamation,
  faEllipsisVertical,
  faRocket,
  faTag,
  faFlag,
  faShield,
  faDesktop,
  faGlobe,
  faPlay,
  faStop,
  faMagnifyingGlass,
  faClock,
  faArrowPointer,
  faCloud,
  faCloudArrowUp,
  faRandom,
  faMobile,
  faKey,
  faSpinner,
  faSpinnerThird,
  faFileDownload,
  faSortAsc,
  faSortDesc,
  faSort,
  faXmark,
  faFlask,
  faSliders,
  faArrowLeftToBracket,
  faBarChart,
  faCheck,
  faCheckSquare,
  faArrowTurnDownRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faExclamationCircle,
  faAddressBook,
  faLink,
  faLinkSlash,
  faCircle,
  faBookOpen,
  faScreenUsers,
  faCopy,
  faArrowUpRightFromSquare,
  faFileArrowDown,
  faNewspaper,
  // @ts-ignore
} from "@awesome.me/kit-b56161fd23/icons/classic/solid";

// Brands icons
import {
  faGoogle,
  faMicrosoft,
  faYoutube,
  // @ts-ignore
} from "@awesome.me/kit-b56161fd23/icons/classic/brands";

// Light icons
import {
  faCircleCheck,
  faGlobe as faGlobeLight,
  faCloudArrowUp as faCloudArrowUpLight, // @ts-ignore
} from "@awesome.me/kit-b56161fd23/icons/classic/light";

// Light icons
import {
  faEnvelope as faEnvelopeRegular,
  faCopy as faCopyRegular,
  // @ts-ignore
} from "@awesome.me/kit-b56161fd23/icons/classic/regular";

// Sharp Light icons
import {
  faArrowUpRightFromSquare as faArrowUpRightFromSquareSharp,
  faCircleCheck as faCircleCheckSharp,
  // @ts-ignore
} from "@awesome.me/kit-b56161fd23/icons/sharp/light";

/**
 * Kicks off an initial replacement of imported FA idiomatic text elements to SVGs, and configures a MutationObserver to replace any new elements added to the DOM.
 *
 * This function should be called once in the application's lifecycle.
 *
 * Example: <i class="fas fa-user" /> will be converted to <svg ... />
 */

/**
 * If needed any new (not imported) icon, add it here and import it from the correct path.
 */
export function replaceIdiomaticTextsWithSvgs(): void {
  // Add imported icons to the library
  library.add(
    // Solid icons
    faRefresh,
    faPlus,
    faGear,
    faChevronLeft,
    faInfoCircle,
    faUsers,
    faArrowLeftToBracket,
    faUser,
    faUserCircle,
    faTimes,
    faPencil,
    faTrash,
    faFloppyDisk,
    faPrint,
    faDownload,
    faArrowRight,
    faTrashCan,
    faExchange,
    faObjectGroup,
    faCalendarCheck,
    faCalendarDays,
    faCalendarDay,
    faCalendarWeek,
    faCalendarLines,
    faCalendarArrowUp,
    faCalendarRange,
    faEye,
    faEllipsis,
    faExclamationTriangle,
    faCaretLeft,
    faLongArrowDown,
    faLongArrowUp,
    faRotate,
    faRotateLeft,
    faWifi,
    faArrowDown,
    faEdit,
    faArrowsRotate,
    faCircleQuestion,
    faBell,
    faBan,
    faSearch,
    faFile,
    faCog,
    faSave,
    faLock,
    faComment,
    faPhone,
    faEnvelope,
    faPaperPlane,
    faQuestion,
    faCheckCircle,
    faWarning,
    faBookmark,
    faLinkSimpleSlash,
    faCircleMinus,
    faAnalytics,
    faFileAlt,
    faShieldHalved,
    faFilter,
    faEarthAmericas,
    faFamily,
    faBug,
    faChevronDown,
    faChevronRight,
    faBellExclamation,
    faEllipsisVertical,
    faRocket,
    faTag,
    faFlag,
    faShield,
    faDesktop,
    faGlobe,
    faPlay,
    faStop,
    faMagnifyingGlass,
    faClock,
    faArrowPointer,
    faCloud,
    faCloudArrowUp,
    faRandom,
    faMobile,
    faKey,
    faSpinner,
    faSpinnerThird,
    faFileDownload,
    faSortAsc,
    faSortDesc,
    faSort,
    faXmark,
    faFlask,
    faSliders,
    faBarChart,
    faCheck,
    faCheckSquare,
    faArrowTurnDownRight,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faExclamationCircle,
    faAddressBook,
    faLink,
    faLinkSlash,
    faCircle,
    faBookOpen,
    faScreenUsers,
    faCopy,
    faArrowUpRightFromSquare,
    faFileArrowDown,
    faNewspaper,

    // Brands icons
    faGoogle,
    faMicrosoft,
    faYoutube,

    // Light icons
    faCircleCheck,
    faGlobeLight,
    faCloudArrowUpLight,

    // Regular icons
    faEnvelopeRegular,
    faCopyRegular,

    // Sharp Light icons
    faArrowUpRightFromSquareSharp,
    faCircleCheckSharp
  );

  // Replace all <i> elements with <svg> elements
  dom.watch();
}
